import { Injectable } from '@angular/core';
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '../session/app-session.service';

import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AppRouteGuard  {

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this._sessionService.user) {
            this._router.navigate(['/account/login']);
            return false;
        }

        if (!route.data || !route.data['permission']) {
            return true;
        }

        if (this._permissionChecker.isGranted(route.data['permission'])) {
            return true;
        }

        this._router.navigate([this.selectBestRoute()]);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    selectBestRoute(): string {
        if (!this._sessionService.user) {
            return '/account/login';
        }

        if (this._permissionChecker.isGranted('Pages.Tenants')) {
            return '/app/tenants';
        }

        if (this._permissionChecker.isGranted('Companies.Read')) {
            return '/app/companies';
        }

        const companyIds = JSON.parse(localStorage.getItem('companyids'));
        if(companyIds &&
            companyIds.length > 0 &&
            (this._permissionChecker.isGranted('User_Companies.Read') || this._permissionChecker.isGranted('User_Companies.Write'))) {
            return '/app/user-companies';
        }

        if(this._permissionChecker.isGranted('User_Natural_Persons.Read')) {
            return '/app/user-persons';
        }

        return '/app/home';
    }
}
